module.exports = __webpack_public_path__ + "assets/img/icon_yy.07e682f7.png";